export default __webpack_public_path__ + "static/media/Nunito-Light.b141e33e.woff";